import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Stack, Paper} from 'views/components';
import {FindReplaceOutlined as FindReplaceIcon} from 'views/icons';
import {Translate, translate} from 'views/module';

const ReplacementPreference = (props) => {
  const {replacementPreference} = props;

  const replacementPreferenceOptions = Object.entries(translate('loomLead.LoomLeadDetail.Careplan.ReplacementPreference.Options'));
  const selectedReplacementPreference = replacementPreference || 'NONE';

  const renderReplacementPreferenceLabel = (value) => {
    const option = replacementPreferenceOptions.find(([optionKey]) => optionKey === value);
    return option?.[1] || value;
  };

  return (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          backgroundColor: 'grey.100',
          justifyContent: 'space-between',
          borderRadius: '4px 4px 0 0',
          width: '100%',
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <FindReplaceIcon sx={{mr: 1}} />
          <Typography variant="h6">
            <Translate expression="loomLead.LoomLeadDetail.Careplan.ReplacementPreference.Title" />
          </Typography>
        </Box>
      </Box>
      <Box sx={{p: 2}}>
        <Stack spacing={1}>
          <Typography variant="subtitle1" sx={{fontWeight: 'bold'}}>
            <Translate expression="loomLead.LoomLeadDetail.Careplan.ReplacementPreference.Field" />
          </Typography>
          <Typography variant="body2">
            {renderReplacementPreferenceLabel(selectedReplacementPreference)}
          </Typography>
        </Stack>
      </Box>
    </Paper>
  );
};

ReplacementPreference.propTypes = {
  replacementPreference: PropTypes.oneOf(['FIND_REPLACEMENT', 'SKIP_VISIT']),
};

export default ReplacementPreference;
